function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16.44v-.24l-.19-.15A8.68 8.68 0 0 1 .5 9.26 8.88 8.88 0 0 1 9.5.5a8.88 8.88 0 0 1 9 8.76 8.89 8.89 0 0 1-9 8.74 9.37 9.37 0 0 1-2.67-.39l-.21-.07-.19.12L4 19.12Z",
    style: {
      fill: "none",
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 7-5.5 5 5-2.36L10.07 12l5.43-5-4.92 2.32Z",
    style: {
      fill: "currentColor"
    }
  }))));
};
export { SvgMessenger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOSAyMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOmN1cnJlbnRDb2xvcjt9LmNscy0ye2ZpbGw6Y3VycmVudENvbG9yO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQsMTYuNDRWMTYuMmwtLjE5LS4xNUE4LjY4LDguNjgsMCwwLDEsLjUsOS4yNiw4Ljg4LDguODgsMCwwLDEsOS41LjVhOC44OCw4Ljg4LDAsMCwxLDksOC43NkE4Ljg5LDguODksMCwwLDEsOS41LDE4YTkuMzcsOS4zNywwLDAsMS0yLjY3LS4zOWwtLjIxLS4wNy0uMTkuMTJMNCwxOS4xMloiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik04LDcsMi41LDEybDUtMi4zNkwxMC4wNywxMiwxNS41LDcsMTAuNTgsOS4zMloiLz48L2c+PC9nPjwvc3ZnPg==";